import { useState } from "react";
import { Mail, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import ComplianceStrip from "../components/ComplianceStrip";
import Seo from "../components/Seo";
import { api, track } from "../lib/api";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please complete all fields.");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks — your message has been sent.");
      track("contact_submitted");
      setForm({ name: "", email: "", message: "" });
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mp-container py-14 max-w-3xl">
      <Seo
        title="Contact MortgagePath"
        description="Get in touch with MortgagePath. For questions about your mortgage options, use the free Mortgage Snapshot or speak to a qualified adviser. We cannot provide regulated mortgage advice."
        path="/contact"
      />
      <div className="text-xs uppercase tracking-widest text-[#0F766E] flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> Contact</div>
      <h1 className="font-sora mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-[#0B1220]">Get in touch</h1>
      <p className="mt-4 text-[#475569] leading-relaxed">
        For questions about your mortgage options, please use the Mortgage Snapshot or speak to a qualified mortgage adviser.
        MortgagePath cannot provide regulated mortgage advice.
      </p>

      <form onSubmit={submit} className="mp-card p-6 sm:p-8 mt-10 grid gap-5">
        <label className="block">
          <span className="mp-label">Your name</span>
          <input type="text" className="mp-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
        </label>
        <label className="block">
          <span className="mp-label">Email address</span>
          <input type="email" className="mp-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
        </label>
        <label className="block">
          <span className="mp-label">Message</span>
          <textarea rows={6} className="mp-input" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
        </label>
        <div className="flex items-center justify-between flex-wrap gap-3">
          <p className="text-xs text-[#475569]">We typically reply within 1–2 working days.</p>
          <button type="submit" disabled={sending} className="mp-btn-primary disabled:opacity-60" data-testid="contact-submit">
            {sending ? <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</> : <>Send message <Send className="w-4 h-4" /></>}
          </button>
        </div>
      </form>

      <div className="mt-8 rounded-xl border border-[#DCE7E3] bg-[#F7FAF9] p-5 text-sm text-[#475569] leading-relaxed" data-testid="contact-company">
        <div className="font-semibold text-[#0B1220]">Home Finance Group Ltd, trading as MortgagePath</div>
        <div className="mt-1">Company number: 17288752</div>
        <div>Registered office: 128 City Road, London, EC1V 2NX</div>
        <div className="mt-2">General enquiries: <a href="mailto:info@mortgagepath.uk" className="text-[#0F766E] hover:underline" data-testid="contact-email-link">info@mortgagepath.uk</a></div>
      </div>

      <div className="mt-8"><ComplianceStrip /></div>
    </div>
  );
};

export default Contact;
